import React, { useEffect, useState } from 'react';

import { Container, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import DashboardInfoBoxResolver from 'components/_paymentStageInfoBoxes/DashboardInfoBoxResolver/DashboardInfoBoxResolver';
import ArticleTilesGrid from 'components/ArticleTilesGrid';
import Jumbotron from 'components/Jumbotron';
import MobileGuttersContainer from 'components/MobileGuttersContainer';
import Section from 'components/Section';
import articleEndpoints from 'config/api/article/article';
import { parseContentItemForFE } from 'config/api/selfTests/parsers';
import CONTENT_TYPES from 'config/constants/CONTENT_TYPES';
import useApiCall from 'hooks/useApiCall';
import title_messages from 'messages/title_messages';
import userDataStorage from 'storages/userDataStorage';

import ActivitiesSection from './_components/ActivitiesSection/ActivitiesSection';
import AssetTaskTable from './_components/AssetTaskTable/AssetTaskTable';
import MyAssetsRiskAnalysisTable from './_components/MyAssetsRiskAnalysisTable/MyAssetsRiskAnalysisTable';
import MyAssetsRiskAnalysisTasksTable from './_components/MyAssetsRiskAnalysisTasksTable/MyAssetsRiskAnalysisTasksTable';
import RecommendedSection from './_components/RecommendedSection/RecommendedSection';
import UpcomingMeetingsDashboardFeed from './_components/UpcomingMeetingsDashboardFeed/UpcomingMeetingsDashboardFeed';

const DashboardPage = () => {
  const theme = useTheme();
  const upMd = useMediaQuery(theme.breakpoints.up('md'));
  const { apiCall } = useApiCall();

  const [articlesData, setArticlesData] = useState(null);
  const getArticlesData = async () => {
    const { data } = await apiCall(articleEndpoints.getSaved());
    const parsedData = parseContentItemForFE(data);
    setArticlesData(parsedData);
  };

  const userData = userDataStorage.get() || {};

  useEffect(() => {
    getArticlesData();
  }, []);

  return (
    <Container disableGutters={!upMd}>
      <Jumbotron>
        <Typography component='h1' variant='h1'>
          {userData ? `${userData.first_name} ${userData.last_name}` : <Skeleton height={80} variant='text' width={320} />}
        </Typography>
      </Jumbotron>
      <DashboardInfoBoxResolver />
      <MobileGuttersContainer>
        <AssetTaskTable />
      </MobileGuttersContainer>
      <MobileGuttersContainer>
        <MyAssetsRiskAnalysisTable />
      </MobileGuttersContainer>
      <MobileGuttersContainer>
        <MyAssetsRiskAnalysisTasksTable />
      </MobileGuttersContainer>
      <MobileGuttersContainer>
        <UpcomingMeetingsDashboardFeed />
      </MobileGuttersContainer>
      <ActivitiesSection />
      <MobileGuttersContainer>
        <Section noMargin title={title_messages.recommended_content}>
          <RecommendedSection />
        </Section>
      </MobileGuttersContainer>
      <MobileGuttersContainer>
        <Section title={title_messages.saved_articles}>
          <ArticleTilesGrid data={articlesData} type={CONTENT_TYPES.ARTICLE} />
        </Section>
      </MobileGuttersContainer>
    </Container>
  );
};

export default DashboardPage;
